import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './FatFeatureList.css';
import { trackFatFeatureClick } from './tracking';
import { IFatFeature } from '../../types';
import { filterFatFeautreItems } from '../../utils/fatFeatures';
import { isArrayWithItems } from '../../utils/helpers';
import { TinySlider } from '../Carousel/TinySlider';
import { controlNextIcon, controlPrevIcon } from '../Carousel/constants';
import { FatFeature } from '../FatFeature';

export interface IFatFeatureStoreProps {
  featureList: IFatFeature[];
  isHidden: boolean;
}

export interface IFatFeatureOwnProps {
  isMobile?: boolean;
}

type IFatFeatureProps = IFatFeatureStoreProps & IFatFeatureOwnProps;

export function FatFeatureList({ featureList, isHidden, isMobile }: IFatFeatureProps) {
  const tinySliderProps = {
    onClick: trackFatFeatureClick,
    settings: {
      controls: !isMobile,
      controlsText: [controlPrevIcon, controlNextIcon],
      fixedWidth: 211,
      nav: false,
      touch: true,
      mouseDrag: true,
      edgePadding: 0,
      gutter: 12,
      speed: 300,
      loop: true,
      lazyload: false,
      preventActionWhenRunning: true,
      preventScroll: true,
      autoWidth: true,
    },
  };
  const filteredFeatureList = filterFatFeautreItems(featureList);
  if (isHidden || !isArrayWithItems(filteredFeatureList)) {
    return null;
  }

  return (
    <div {...mergeStyles(styles['container'], isMobile && styles['mobile_container'])}>
      <h2 {...mergeStyles(styles['title'], isMobile && styles['mobile_title'])}>Чем интересен этот посёлок?</h2>
      <div {...mergeStyles(styles['list'], isMobile && styles['mobile_list'])}>
        <TinySlider {...tinySliderProps}>
          {filteredFeatureList.map(({ id, imageUrl, text }) => (
            <FatFeature key={id} text={text} imageUrl={imageUrl} />
          ))}
        </TinySlider>
      </div>
    </div>
  );
}
